define('lib/easing',[], function () {

    "use strict";

    return {
        /**
         * Easing function with range specified
         * t value can be outside the range given, but the return value will always be within 0 and 1
         * @param  {float}  t
         * @param  {array}  range   Range where t value ease against with
         * @param  {string} ease    Easing function name
         * @return {float}          float within 0 and 1
         */
        range: function (t, range, ease) {
            t = t <= range[0] ? range[0] : (t >= range[1] ? range[1] : t); // limit t inside the range
            return this[ease]( (t - range[0]) / (range[1] - range[0]) );
        },
        // no easing, no acceleration
        linear: function (t) { return t; },
        // accelerating from zero velocity
        easeInQuad: function (t) { return t*t; },
        // decelerating to zero velocity
        easeOutQuad: function (t) { return t*(2-t); },
        // acceleration until halfway, then deceleration
        easeInOutQuad: function (t) { return t<0.5 ? 2*t*t : -1+(4-2*t)*t; },
        // accelerating from zero velocity 
        easeInCubic: function (t) { return t*t*t; },
        // decelerating to zero velocity 
        easeOutCubic: function (t) { return (--t)*t*t+1; },
        // acceleration until halfway, then deceleration 
        easeInOutCubic: function (t) { return t<0.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1; },
        // accelerating from zero velocity 
        easeInQuart: function (t) { return t*t*t*t; },
        // decelerating to zero velocity 
        easeOutQuart: function (t) { return 1-(--t)*t*t*t; },
        // acceleration until halfway, then deceleration
        easeInOutQuart: function (t) { return t<0.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t; },
        // accelerating from zero velocity
        easeInQuint: function (t) { return t*t*t*t*t; },
        // decelerating to zero velocity
        easeOutQuint: function (t) { return 1+(--t)*t*t*t*t; },
        // acceleration until halfway, then deceleration 
        easeInOutQuint: function (t) { return t<0.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t; }
    };

});
